import React from 'react';
import { useSelector} from 'react-redux';
import CustomTimePicker from '../../../../../components/CustomTimePicker';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelect } from '../../../../../components/CustomSelect';
import { InputAdornment } from '@mui/material';
import {useTranslation} from 'react-i18next';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ScheduleTime = ({item, disabled, onChange, emptyFields, isValidTime, isValidMealTime=true, isValidFoodsPerDay=true, rangeMealTime, rangeFoodsPerDay}) => {
    const { t } = useTranslation();
    const { getAllDepartments } = useSelector((state) => state.DocumentPanelSlice);

    return (
        <>
            <div className='row'>
               {(!item?.id || item?.departmentId) && (
                <div className='col-12 col-md-12'>
                    <CustomSelect
                        id='slt_st_departments'
                        trans='departments'
                        name='departmentId'
                        keyName='id'
                        value={item?.departmentId}
                        onChange={onChange}
                        list={getAllDepartments}
                        showNoSelectionOption={false}
                        disabled={disabled || (!item?.departmentId && item.id)}
                        required={true}
                        emptyFields={emptyFields && !item?.departmentId && !item.id}
                    />
                </div>
                )}
            </div>
            <div className="row">
            <div className='col-12 col-md-6'>
                <CustomTimePicker
                    id='dtp_st_starts_at'
                    title={t('starts_at')}
                    name={'startsShiftAt'}
                    value={item?.startShiftAt}
                    handleChange={(value)=>{
                        onChange({target:{name:"startShiftAt", value:value}});
                    }}
                    disabled={disabled}
                    ampm={false}
                    required={true}
                    emptyFields={emptyFields}
                />
            </div>
            <div className='col-12 col-md-6'>
                <CustomTimePicker
                    id='dtp_st_ends_at'
                    title={t('ends_at')}
                    name={'endShiftAt'}
                    value={item?.endShiftAt}
                    handleChange={(value)=>{
                        onChange({target:{name:"endShiftAt", value:value}});
                    }}
                    disabled={disabled}
                    ampm={false}
                    required={true}
                    emptyFields={emptyFields}

                    minTime={item.startShiftAt}
                    isValid={isValidTime}
                    isValidText='time_invalid'
                />
            </div>
            <div className='col-12 col-md-6'>
                <CustomTextField
                    id='txt_st_meal_duration'
                    trans='meal_duration'
                    name='mealTime'
                    value={item?.mealTime}
                    onChange={onChange}
                    disabled={disabled}
                    required={true}
                    emptyFields={emptyFields}
                    type='number'
                    length={3}
                    isValid={isValidMealTime}
                    isValidText={t('validation_meals_access_department', { valueValidation: `${rangeMealTime?.start} - ${rangeMealTime?.end}` })}
                    helperText={t('validation_meals_access_department', { valueValidation: `${rangeMealTime?.start} - ${rangeMealTime?.end}` })}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <span>{t('min')?.toUpperCase()}</span>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div className='col-12 col-md-6'>
                <CustomTextField
                    id='txt_st_foods_per_day'
                    trans='authorized_meals'
                    name='foodsPerDay'
                    value={item?.foodsPerDay}
                    onChange={onChange}
                    disabled={disabled}
                    required={true}
                    emptyFields={emptyFields}
                    type='number'
                    length={1}
                    isValid={isValidFoodsPerDay}
                    isValidText={t('validation_meals_authorized_access_department', { valueValidation: `${rangeFoodsPerDay?.start} - ${rangeFoodsPerDay?.end}` })}
                    helperText={t('validation_meals_authorized_access_department', { valueValidation: `${rangeFoodsPerDay?.start} - ${rangeFoodsPerDay?.end}` })}
                />
            </div>
            </div>
        </>
    );
};

export default ScheduleTime;
